module.exports = __webpack_public_path__ + "static/media/Broken bridge.29820cf7.png";